import DossierService from "./DossierService";
import { API_FILES_HEADERS, API_HEADERS, liferayConfig } from "./utils";

class UserService{
    constructor() {
        this.liferayConfig = liferayConfig;
        this.nwHeaders = API_HEADERS;
        this.flHeadears = API_FILES_HEADERS;
    }

    async userDossier(search){
        try {
            const personERC = await this.userInfos();
            const person = await this.userPersonneIds(personERC.r_personnePhysique_c_personneERC)
            const dossiers = await this.userPersonneDossiers(person.id, search);

            return dossiers.items;
        } catch (error) {
            console.log("Une erreur est survenue lors du chargement de dossier", error)
            return [];
        }
    }

    async userInfos() {
        try {

            const url = `${this.liferayConfig.baseUrl}/o/headless-admin-user/v1.0/my-user-account?fields=r_personnePhysique_c_personneERC`;
            const response = await fetch(url, {
                method: 'GET',
                headers: this.nwHeaders
            });

            const data = await response.json();
            if (data.totalCount === 0) {
                return {};
            }
            return data || {};
        } catch (error) {
            console.error('Error fetching affaires:', error);
            return {};
        }
    }

    // async nbreSectionDosCompl(){
    //     try {
    //         const dossier = await this.userDossier();
    //         const nbreSectionDos = await this.dossierService.allDossierSections(dossier.id)
    //         return nbreSectionDos
    //     } catch (error) {
    //         console.log("Une erreur est survenue lors du chargement de dossier", error)
    //     }
    // }

    // async nbreSectionDos(){
    //     try {
    //         const dossier = await this.userDossier();
    //         const nbreSectionDos = await this.dossierService.numberDossierSectionsComplete(dossier.id)
    //         return nbreSectionDos
    //     } catch (error) {
    //         console.log("Une erreur est survenue lors du chargement de dossier", error)
    //     }
    // }

    async userPersonneIds(extCode) {
        try {

            const url = `${this.liferayConfig.baseUrl}/o/c/personnes/scopes/${this.liferayConfig.groupId}/by-external-reference-code/${extCode}?fields=id`;
            const response = await fetch(url, {
                method: 'GET',
                headers: this.nwHeaders
            });

            const data = await response.json();
            if (data.totalCount === 0) {
                return {};
            }
            return data || {};
        } catch (error) {
            console.error('Error fetching affaires:', error);
            return {};
        }
    }

    async userPersonneDossiers(code, search) {
        try {

            const filter = search ? `?filter={"code":"${search}"}` : '';

            const url = `${this.liferayConfig.baseUrl}/o/c/personnes/${code}/personnePhysiqueDossier`;
            const response = await fetch(url, {
                method: 'GET',
                headers: this.nwHeaders
            });

            const data = await response.json();
            if (data.totalCount === 0) {
                return [];
            }
            return data || [];
        } catch (error) {
            console.error('Error fetching affaires:', error);
            return [];
        }
    }


    async naissancesPerPage(pageNumber, pageSize) {
        try {

            const url = `${this.liferayConfig.baseUrl}/o/c/actedenaissances/scopes/${this.liferayConfig.groupId}?page=${pageNumber}&pageSize=${pageSize}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.liferayConfig.authToken,
                    // 'X-CSRF-Token': window?.Liferay.authToken,
                },
            });

            const data = await response.json();
            if (data.totalCount === 0) {
                return [];
            }
            return data.items || [];
        } catch (error) {
            console.error('Error fetching affaires:', error);
            return [];
        }
    }

    async allNaissances() {
        const totalCount = await this.naissancesNumber();
        console.log("Total Count ==>", totalCount)
        const pageSize = 30;
        const totalPages = Math.ceil(totalCount / pageSize);

        // Récupérer toutes les pages en parallèle
        const promises = Array.from({ length: totalPages }, (_, i) =>
            this.naissancesPerPage(i + 1, pageSize)
        );

        const results = await Promise.all(promises);
        const allNais = results.flat();

        allNais.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
        this.actesNaissances = allNais;
        return this.actesNaissances;
    }

    async naissancesNumber() {
        const url = `${this.liferayConfig.baseUrl}/o/c/actedenaissances/scopes/${this.liferayConfig.groupId}?fields=totalCount`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: this.liferayConfig.authToken,
                    // 'X-CSRF-Token': window?.Liferay.authToken,
                },
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            const data = await response.json();
            console.log(data);

            return data.totalCount || 0;
        } catch (error) {
            console.error("Erreur lors de la récupération des informations de l'acte:", error);
            return 0;
        }
    }

    async updateDemandeActeNaissance(payloadActeDeNaissance) {
        const url = `${this.liferayConfig.baseUrl}/o/c/actedenaissances/${payloadActeDeNaissance?.acteDeNaissanceId}`;
        try {
            const payload = { workflowStatus: payloadActeDeNaissance?.workflowStatus }
            const response = await fetch(url, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.liferayConfig.authToken,
                    // 'X-CSRF-Token': window?.Liferay.authToken,
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) { throw new Error(`Erreur HTTP: ${response.status}`); }
            const data = await response.json();
            return data;
        } catch (error) {
            console.log("🚀 ~ NaissanceService ~ updateDemandeActeNaissance ~ error:", error)
            return 0;
        }
    }
}
export default UserService;